import { combineReducers } from 'redux';

import idUsuariSeleccionat from './idUsuariSeleccionat';
import dades from './dades';
import peticioEnviarFormulariEnCurs from './peticioEnviarFormulariEnCurs';
import peticioObtenirDadesEnCurs from './peticioObtenirDadesEnCurs';
import mostrarErrors from './mostrarErrors';

export default combineReducers({
    idUsuariSeleccionat,
    dades,
    peticioEnviarFormulariEnCurs,
    peticioObtenirDadesEnCurs,
    mostrarErrors
});



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/index.js